module.exports = __webpack_public_path__ + "img/40.e4341f0b.jpeg";